import {ValueObject} from '@s-ui/domain'

export class ElectricFeaturesValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.batteryCapacity,
   * @param {String} params.batteryType,
   * @param {String} params.consumptionAverageElectricWltp,
   * @param {String} params.electricAutonomy,
   * @param {String} params.electricChargingTime,
   * @param {String} params.fastChargingTime,
   * @param {String} params.fuelConsumptionCombined,
   * @param {String} params.fuelConsumptionStandard,
   * @param {String} params.maximumBatteryKWH,
   * @param {String} params.maxPower,
   * @param {String} params.onboardCharger
   * */
}
